<template>
  <div>
    <b-card
      no-body
    >
      <b-card-header class="pb-50">
        <h5>
          {{ $t('futures.relatorio.sinal.tittleFiltros') }}
        </h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="2"
            class="mb-md-0 mb-2"
          >
            <label>{{ $t('futures.relatorio.sinal.dataInicial') }}</label>
            <flat-pickr
              v-model="dataBuscaFilter.inicio"
              class="form-control"
              :config="{ altInput: true, enableTime: false, altFormat: 'd/m/Y', locale: Portuguese}"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-md-0 mb-2"
          >
            <label>{{ $t('futures.relatorio.sinal.dataFinal') }}</label>
            <flat-pickr
              v-model="dataBuscaFilter.fim"
              class="form-control"
              :config="{ altInput: true, enableTime: false, altFormat: 'd/m/Y', locale: Portuguese}"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-md-0 mb-2"
          >
            <label>{{ $t('spot.relatorio.labelCoin') }}</label>
            <b-form-input
              id="coin"
              v-model="dataBuscaFilter.coin"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-md-0 mb-2"
          >
            <label>{{ $t('futures.relatorio.sinal.status') }}</label>
            <v-select
              v-model="statusSinalFilter"
              :options="statusSinalOptions"
              class="w-100"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-md-0 mb-2"
          >
            <label>{{ $t('futures.relatorio.sinal.trader') }}</label>
            <v-select
              v-model="traderFilter"
              :options="traderOptions"
              :clearable="true"
              class="w-100"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-md-0 mb-2"
          >
            <label style="visibility:hidden">{{ $t('futures.relatorio.sinal.acao') }}</label>
            <b-button
              v-ripple.400="'rgba(59, 130, 246, 0.15)'"
              variant="outline-primary"
              class="form-control"
              @click.prevent="buscarFiltro"
            >
              {{ $t('futures.relatorio.sinal.pesquisarBtn') }}

            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card
      no-body
    >
      <b-card-header class="pb-50">
        <h5>
          {{ $t('futures.relatorio.sinal.titleResumo') }}

        </h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col lg="6">
            <grafico-sinal-fut
              :resumo-sinal="resumo"
              :series="series"
            />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- Table Container Card -->
    <b-card
      no-body
    >
      <b-table
        ref="refListTable"
        :items="dataList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('futures.emptyText')"
        :sort-desc.sync="isSortDirDesc"
        striped
      >
        <template #cell(id)="data">
          <div class="text-nowrap">
            <span
              v-if="false"
              class="bullet bullet-sm mr-1"
              :class="`bullet-${getCorStatus(data.item.executado)}`"
            />
            <span>{{ data.value }}</span>
          </div>
        </template>

        <template #cell(paridade)="data">
          <div class="text-nowrap">
            <b-avatar
              size="sm"
              :src="getIcon(data.item.moedaTrade)"
            />
            <span class="mr-1">
              {{ data.item.moedaTrade }}<span class="font-weight-light">/{{ data.item.paridadeTrade }}</span>
            </span>
          </div>
        </template>

        <template #cell(ordemPosition)="data">
          <div class="text-nowrap">
            {{ data.value }}
            <b-badge variant="light-warning">
              {{ data.item.alavancagem }}x
            </b-badge>
          </div>
        </template>

        <template #cell(valorEntrada)="data">
          <div class="text-nowrap">
            {{ data.item.valorEntradaMedio }}
          </div>
        </template>

        <template #cell(porcentagem)="data">
          <div class="text-nowrap">
            <template v-if="data.value!=''">
              {{ data.value }}%
            </template>
            <template v-else />
          </div>
        </template>

        <template #cell(alvo1)="data">
          <div class="text-nowrap">

            <template v-if="data.value">
              {{ data.value }} <br>
              <template v-if="data.item.ordemPosition=='Long'">
                <b-badge variant="light-success">
                  {{ getPercentDiff(data.item.valorEntradaMedio, data.value) }}%
                </b-badge>
              </template>
              <template v-else>
                <b-badge variant="light-success">
                  {{ getPercentDiff(data.value, data.item.valorEntradaMedio) }}%
                </b-badge>
              </template>

              <feather-icon
                v-if="data.item.dataAlvo1!=null"
                class="text-success mr-1"
                size="16"
                icon="CheckIcon"
              />
            </template>
            <template v-else>
              -
            </template>
          </div>
        </template>

        <template #cell(valorEncerrado)="data">
          <div
            v-if="data.item.status!='Cancelado'"
            class="text-nowrap"
          >
            {{ data.value }}
            <template v-if="data.value">
              <br>
              <template v-if="data.item.ordemPosition=='Long'">
                <template v-if="getPercentDiff(data.item.valorEntradaMedio, data.value)>=0">
                  <b-badge variant="light-success">
                    {{ getPercentDiff(data.item.valorEntradaMedio, data.value) }}%
                  </b-badge>
                  <feather-icon
                    v-if="data.item.dataEncerrado!=null"
                    class="text-success mr-1"
                    size="16"
                    icon="CheckIcon"
                  />
                </template>
                <template v-else>
                  <b-badge variant="light-danger">
                    {{ getPercentDiff(data.item.valorEntradaMedio, data.value) }}%
                  </b-badge>
                  <feather-icon
                    v-if="data.item.dataEncerrado!=null"
                    class="text-danger mr-1"
                    size="16"
                    icon="XIcon"
                  />
                </template>
              </template>
              <template v-if="data.item.ordemPosition=='Short'">
                <template v-if="getPercentDiff(data.value, data.item.valorEntradaMedio)>=0">
                  <b-badge variant="light-success">
                    {{ getPercentDiff(data.value, data.item.valorEntradaMedio) }}%
                  </b-badge>
                  <feather-icon
                    v-if="data.item.dataEncerrado!=null"
                    class="text-success mr-1"
                    size="16"
                    icon="CheckIcon"
                  />
                </template>
                <template v-else>
                  <b-badge variant="light-danger">
                    {{ getPercentDiff(data.value, data.item.valorEntradaMedio) }}%
                  </b-badge>
                  <feather-icon
                    v-if="data.item.dataEncerrado!=null"
                    class="text-danger mr-1"
                    size="16"
                    icon="XIcon"
                  />
                </template>
              </template>
            </template>

            <template v-else>
              -
            </template>
          </div>
        </template>

        <template #cell(stopLoss)="data">
          <div class="text-nowrap">
            <template v-if="data.value">
              {{ data.value }}
              <br>
              <template v-if="data.item.ordemPosition=='Long'">
                <b-badge variant="light-danger">
                  {{ getPercentDiff(data.item.valorEntradaMedio, data.value) }}%
                </b-badge>
              </template>
              <template v-else>
                <b-badge variant="light-danger">
                  {{ getPercentDiff(data.value, data.item.valorEntradaMedio) }}%
                </b-badge>
              </template>
              <feather-icon
                v-if="data.item.dataStopLoss!=null"
                class="text-danger mr-1"
                size="16"
                icon="XIcon"
              />
            </template>
            <template v-else>
              -
            </template>
          </div>
        </template>

        <template #cell(dataCriacao)="data">
          {{ formatDateTimeSemAnoBR(data.value) }}
        </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">{{ $t('futures.textMuted', { from: paginationMeta.from, to: paginationMeta.to, of: paginationMeta.of }) }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalCount"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>

    </b-card>
  </div>
</template>

<script>

import {
  BCard, BTable, BAvatar, BPagination, BRow, BCol, BBadge, BCardHeader, BCardBody, BButton, VBTooltip, BFormInput,
} from 'bootstrap-vue'
import store from '@/store'
import utilsMixin from '@/mixins/utilsMixin'
import { formatDateTimeSemAnoBR, percentDiferenca, toIsoStringTimeZone } from '@/utils/filter'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import Ripple from 'vue-ripple-directive'
import sinalStoreModule from './sinalStoreModule'

const SINAL_FUT_STORE_MODULE_NAME = 'sinal-relatorio-fut'

export default {

  components: {
    BCard,
    BTable,
    BAvatar,
    BPagination,
    BRow,
    BCol,
    BBadge,
    BCardHeader,
    BCardBody,
    flatPickr,
    BButton,
    vSelect,
    BFormInput,
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  mixins: [utilsMixin],

  data() {
    return {
      Portuguese,
      formatDateTimeSemAnoBR,
      percentDiferenca,
      perPage: 10,
      totalCount: 0,
      currentPage: 1,
      sortBy: 'id,desc',
      isSortDirDesc: true,
      dataList: [],
      dataBuscaFilter: {
        coin: null,
        inicio: new Date(new Date().getFullYear(), new Date().getMonth(), '01'), // primeiro dia do mes atual
        fim: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
      },
      resumo: {
        totalPorcent: 0,
      },
      series: [],
      statusSinalFilter: { label: 'Todos', value: null },
      traderFilter: null,
      traderOptions: [],
    }
  },

  computed: {
    statusSinalOptions() {
      return [
        { label: this.$i18n.t('futures.relatorio.sinal.todos'), value: null },
        { label: this.$i18n.t('futures.relatorio.sinal.ativo'), value: '0' },
        { label: this.$i18n.t('futures.relatorio.sinal.fechado'), value: '1' },
        { label: this.$i18n.t('futures.relatorio.sinal.cancelado'), value: '2' },
      ]
    },
    tableColumns() {
      return [
        { key: 'id', label: this.$i18n.t('futures.relatorio.sinal.tableHeader.id') },
        { key: 'paridade', label: this.$i18n.t('futures.relatorio.sinal.tableHeader.paridade') },
        { key: 'ordemPosition', label: this.$i18n.t('futures.relatorio.sinal.tableHeader.ordemPosition') },
        { key: 'status', label: this.$i18n.t('futures.relatorio.sinal.tableHeader.status') },
        { key: 'ordemTipoCompra', label: this.$i18n.t('futures.relatorio.sinal.tableHeader.ordemTipoCompra') },
        { key: 'valorEntrada', label: this.$i18n.t('futures.relatorio.sinal.tableHeader.valorEntrada') },
        { key: 'alvo1', label: this.$i18n.t('futures.relatorio.sinal.tableHeader.alvo1') },
        { key: 'valorEncerrado', label: this.$i18n.t('futures.relatorio.sinal.tableHeader.valorEncerrado') },
        { key: 'stopLoss', label: this.$i18n.t('futures.relatorio.sinal.tableHeader.stopLoss') },
        { key: 'porcentagem', label: this.$i18n.t('futures.relatorio.sinal.tableHeader.porcentagem') },
        { key: 'dataCriacao', label: this.$i18n.t('futures.relatorio.sinal.tableHeader.dataCriacao') },
        { key: 'agente', label: this.$i18n.t('futures.relatorio.sinal.tableHeader.trader') },
      ]
    },
    paginationMeta() {
      const localItemsCount = this.$refs.refListTable ? this.$refs.refListTable.localItems.length : 0
      return {
        from: this.perPage * (this.currentPage - 1) + (localItemsCount ? 1 : 0),
        to: this.perPage * (this.currentPage - 1) + localItemsCount,
        of: this.totalCount,
      }
    },
    getCorStatus() {
      return value => {
        if (value) {
          return 'success'
        }
        return 'danger'
      }
    },
  },

  watch: {
    currentPage() {
      this.fetchList()
      this.$refs.refListTable.refresh()
    },
  },

  created() {
    if (!store.hasModule(SINAL_FUT_STORE_MODULE_NAME)) store.registerModule(SINAL_FUT_STORE_MODULE_NAME, sinalStoreModule)
    this.fetchTraders()
    this.fetchList()
  },

  beforeDestroy() {
    if (store.hasModule(SINAL_FUT_STORE_MODULE_NAME)) store.unregisterModule(SINAL_FUT_STORE_MODULE_NAME)
  },

  methods: {

    fetchTraders() {
      store.dispatch('sinal-relatorio-fut/getTraders')
        .then(response => {
          this.traderOptions = response.data.map(t => ({ label: t.nome, value: t.id }))
        })
    },

    buscarFiltro() {
      if (this.isDataRangeDias(this.dataBuscaFilter.inicio, this.dataBuscaFilter.fim, 90)) {
        this.currentPage = 1
        this.fetchList()
      }
    },

    fetchList() {
      let dataInicio = this.dataBuscaFilter.inicio
      if (typeof (dataInicio) === 'string' || dataInicio instanceof String) {
        dataInicio = toIsoStringTimeZone(new Date(dataInicio.split('-')[0], dataInicio.split('-')[1] - 1, dataInicio.split('-')[2]))
      }

      let dataFim = this.dataBuscaFilter.fim

      if (typeof (dataFim) === 'string' || dataFim instanceof String) {
        const dataFimTemp = new Date(dataFim.split('-')[0], dataFim.split('-')[1] - 1, dataFim.split('-')[2])
        dataFim = new Date(dataFimTemp.setDate(dataFimTemp.getDate() + 1)).toISOString()
      } else {
        dataFim = new Date(dataFim.setDate(dataFim.getDate() + 1))
      }

      store
        .dispatch('sinal-relatorio-fut/getSinaisResumo', {
          size: this.perPage,
          page: this.currentPage - 1,
          sortBy: this.sortBy,
          sortDesc: this.isSortDirDesc,
          dataInicio,
          dataFim,
          statusSinal: this.statusSinalFilter.value,
          coin: this.dataBuscaFilter.coin,
          agentePerfilTradeId: this.traderFilter ? this.traderFilter.value : null,
        })
        .then(response => {
          this.resumo = response.data
          this.series = [response.data.totalAtivoPercent, response.data.totalGanhoPercent, response.data.totalPerdaPercent]
        })

      store
        .dispatch('sinal-relatorio-fut/getSinais', {
          size: this.perPage,
          page: this.currentPage - 1,
          sortBy: this.sortBy,
          sortDesc: this.isSortDirDesc,
          dataInicio,
          dataFim,
          statusSinal: this.statusSinalFilter.value,
          coin: this.dataBuscaFilter.coin,
          agentePerfilTradeId: this.traderFilter ? this.traderFilter.value : null,
        })
        .then(response => {
          const { content, totalElements } = response.data
          this.dataList = content
          this.totalCount = totalElements
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao recuperar a lista.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
